import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { usersOwnTractorsApiUrl } from '../../../../api/product/queries/getUsersOwnTractors';
import { IUserOwnTractorDetail } from '../../../../interfaces/OwnTractor.interfaces';
import {
  getUsersOwnTractorById,
  IGetUsersOwnTractorByIdParams,
} from '../../../../api/product/queries/getUsersOwnTractorById';

interface IUseGetUsersOwnTractorByIdQueryParams extends IGetUsersOwnTractorByIdParams {
  options?: UseQueryOptions<IUserOwnTractorDetail, AxiosError>;
}

export const useGetUsersOwnTractorById = ({ tractorId, options }: IUseGetUsersOwnTractorByIdQueryParams) => {
  return useQuery<IUserOwnTractorDetail, AxiosError>(
    [usersOwnTractorsApiUrl, tractorId],
    () => getUsersOwnTractorById({ tractorId }),
    { ...options, enabled: !!tractorId },
  );
};
